// extracted by css-extract-rspack-plugin
export default {"colorGray5":"#777777","colorGray9":"#dddddd","colorGray11":"#fbfbfb","yMark":"grid__yMark____ykgZ","xMark":"grid__xMark___QN7RY"};